module.exports = __webpack_public_path__ + "static/media/thankyou_popup.52bb4ef9.png";